<template>
  <div id="admin">
    <menu-admin/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center"><i class="fa fa-user"></i>  {{user.name}}</h1>
          </div>
        </div>
      </div>
    </div>
    <section class="int-form">
      <div class="container">

        <div class="row">
          <div class="col-12">
            <form>
              <div v-show="user.id!==null" class="card-details text-right" style="margin-bottom: 0; padding-bottom: 0">
                <a class="badge badge-info" href="#" @click="loadEtiquettes('simple')" style="color: white !important;">
                  <i class="fa fa-list" aria-hidden="true"></i> Etiqueta Simples
                </a>
                <a class="badge badge-info" href="#" @click="loadEtiquettes('complete')" style="color: white !important;">
                  <i class="fa fa-list" aria-hidden="true"></i> Etiqueta Completa
                </a>
              </div>

              <div class="card-details">
                <div class="row">
                  <div v-show="is_superuser" class="form-group col-sm-3">
                    <label for="company_name">Administrador</label><br/>
                    <select id="is_superuser" class="form-control" v-model="user.user.is_superuser">
                      <option value="true">Sim</option>
                      <option value="false">Não</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                  <div v-show="is_superuser" class="form-group col-sm-3">
                    <label for="cnpj">Funcionário</label><br/>
                    <select id="is_staff" class="form-control" v-model="user.user.is_staff">
                      <option value="true">Sim</option>
                      <option value="false">Não</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-3">
                    <label for="cnpj">Ativo</label><br/>
                    <select id="is_active" class="form-control" v-model="user.user.is_active">
                      <option value="true">Sim</option>
                      <option value="false">Não</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-3">
                    <label for="cnpj">Parceria</label><br/>
                    <select id="is_partner" class="form-control" v-model="user.is_partner">
                      <option value="true">Sim</option>
                      <option value="false">Não</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                  <div v-if="user.temp_hash" class="form-group col-sm-12">
                    <!--<label for="name">Link troca senha</label><br>-->
                    <small><b>Link para troca de senha: </b>
                      <span style="color: #398439">https://pubtec.com.br/change_pass/{{ user.temp_hash }}</span>
                    </small>
                  </div>
                </div>
               <hr/>

                <div class="row">
                  <div class="col-12">
                    <h3 class="subtitle">Detalhes do usuário</h3>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="name">Nome</label>
                    <input id="name" type="text" v-model="user.name" class="form-control" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="user_email">E-mail</label>
                    <input id="user_email" type="text" v-model="user.user.email" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="cpf">CPF</label>
                    <input id="cpf" type="text" v-mask="'###.###.###-##'" class="form-control" v-model="user.cpf" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="ie">IE</label>
                    <input id="ie" type="text" maxlength="12" class="form-control" v-model="user.ie" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="phone">Telefone</label>
                    <input id="phone"  v-mask="['(##) ####-####', '(##) #####-####']" type="text" v-model="user.phone" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                </div>
                <hr/>
                <div class="row">
                  <div class="form-group col-sm-12">
                  <label for="person_or_company"><input type="checkbox" id="person_or_company" v-model="user.person_or_company">Pessoa Jurídica?</label>
                  </div>
                  <div v-show="user.person_or_company" class="form-group col-sm-6">
                    <label for="company_name">Razão Social</label>
                    <input id="company_name" type="text" v-model="user.company_name" class="form-control" placeholder="" aria-label="" value="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div v-show="user.person_or_company" class="form-group col-sm-6">
                    <label for="cnpj">CNPJ</label>
                    <input id="cnpj" v-mask="'##.###.###/####-##'" type="text" v-model="user.cnpj" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                </div>
                <hr/>
                <div class="row">
                  <div class="col-12">
                    <h3 class="subtitle">Endereço de Cobrança</h3>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="billing_address_country">País</label>
                    <input id="billing_address_country" v-model="user.billing_address.country" type="text"  disabled="disabled" value="Brasil" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="billing_address_zip_code">CEP</label>
                    <input id="billing_address_zip_code" v-model="user.billing_address.zip_code" type="text" v-mask="'#####-###'" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="billing_address_street">Endereço</label>
                    <input id="billing_address_street" v-model="user.billing_address.street" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="billing_address_number">Número</label>
                    <input id="billing_address_number" v-model="user.billing_address.number" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="billing_address_complement">Complemento</label>
                    <input id="billing_address_complement" v-model="user.billing_address.complement" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="billing_address_province">Bairro</label>
                    <input id="billing_address_province" v-model="user.billing_address.province" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="billing_address_city">Cidade</label>
                    <input id="billing_address_city" v-model="user.billing_address.city" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="billing_address_state">UF</label>
                    <input id="billing_address_state" v-model="user.billing_address.state" v-mask="'AA'" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-12" v-show="!logged">
                    <input id="checkBoxAddress" type="checkbox"> <label for="checkBoxAddress">usar outro endereço para entrega</label>
                  </div>
                </div>
                <hr/>
                <div class="row" id="shippingAddressBlock" v-show="logged">
                  <div class="col-12">
                    <h3 class="subtitle">Endereço de Entrega</h3>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="shipping_address_country">País</label>
                    <input id="shipping_address_country" v-model="user.shipping_address.country" type="text"  disabled="disabled" value="Brasil" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="shipping_address_zip_code">CEP</label>
                    <input id="shipping_address_zip_code" v-model="user.shipping_address.zip_code" type="text" v-mask="'#####-###'" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="shipping_address_street">Endereço</label>
                    <input id="shipping_address_street" v-model="user.shipping_address.street" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="shipping_address_number">Número</label>
                    <input id="shipping_address_number" v-model="user.shipping_address.number" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="shipping_address_complement">Complemento</label>
                    <input id="shipping_address_complement" v-model="user.shipping_address.complement" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="shipping_address_province">Bairro</label>
                    <input id="shipping_address_province" v-model="user.shipping_address.province" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="shipping_address_city">Cidade</label>
                    <input id="shipping_address_city" v-model="user.shipping_address.city" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="shipping_address_state">UF</label>
                    <input id="shipping_address_state" v-model="user.shipping_address.state" v-mask="'AA'" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                </div>
              </div>
              <div class="card-details" style="padding-top: 0">
                <div class="row">
                  <div class="form-group col-sm-12">
                    <div id="sucessUpdate" class="alert alert-success text-center" role="alert" style="display: none;">As informações foram salvas com sucesso</div>
                    <div id="errorFound" class="alert alert-danger text-center" role="alert" style="display: none">Um erro foi encontrado. Verifique os campos do formulário</div>
                    <button type="button" class="btn btn-secondary" onclick="window.history.back()">Voltar</button>
                    <button type="button" class="btn btn-primary pull-right" @click="saveUser()">Salvar</button>
                  </div>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </section>
    <footer-admin/>
  </div>
</template>

<script>
  import user from "../../api/user"
  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import { mapState } from 'vuex'
  import mixins from "../../helpers/mixins"
  export default {
    name: "AdminUsersView",
    mixins: [mixins],
    data () {
      return {
        user: {
          user: { },
          billing_address: {},
          shipping_address: {}
        },
      }
    },
    components: { menuAdmin, footerAdmin },
    computed: {
      ...mapState({
        'logged': state => state.logged,
        'is_superuser': function(){ return this.$store.getters.isSuperuser  }
      }),
    },
    methods: {
      getUser(id){
          user.get(id).then((response)  =>  {
            this.user = response.data
          })
      },
      loadEtiquettes(type){
        let data_users = {
          users: this.user.id + "",
          type: type
        }
        user.get_addresses(data_users).then((response)  =>  {
            let blob = new Blob([response.data], { type:   'application/pdf' } )
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.string_to_slug(this.user.name) + '_etiqueta_' + type + '.pdf'
            link.click()
        })
      },
      saveUser(){
        $("#sucessUpdate").hide()
        $("#errorFound").hide()
        let user_data = JSON.parse(JSON.stringify(this.user))

        if(user_data.person_or_company) user_data.person_or_company = 1; else user_data.person_or_company = 0;

        user.update(user_data, user_data.id).then((response) => {
              if(response.status === 200){
                $("#sucessUpdate").show()
              } else {
                alert('ATENÇÃO: Não foi possivel atualizar o usuário!');
              }
            }).catch(errors => { this.formErrors(errors) })
      }
    },
    mounted(){
      if(this.$route.params.id != undefined)
        this.getUser(this.$route.params.id)
    }
  }
</script>

<style scoped>
  .jumbotron-fluid{
    padding-top: 100px;
    padding-bottom: 20px;
    margin-bottom: 10px;
  }
</style>